import React, { Component } from 'react';
//import Config from './Config';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/PageState.css';
//import FX from './functions/functions';
class PageState extends Component {
  constructor(props) {
    super(props);
    this.state = {page: 1};
  }
  updatePage = (action, e) => {
    var pages;
    var new_page;
    console.log(pages = Math.ceil(this.props.display.items.count / (this.props.display.items.limit || 30)));
    console.log(action);
    console.log('-------------');
    if( action == '#page_no' ){
        new_page = parseInt(e.target.value.split("/")[0], 10);
        if(new_page >= 1 && new_page <= pages && typeof this.props.setPage === 'function'){
            this.props.setPage({action: new_page});
        }
        return false;
    }
    
    
    if( parseInt(action) && this.props.display.items.page === Math.min(  this.props.display.items.page + parseInt(action), Math.ceil(this.props.display.items.count / (this.props.display.items.limit || 30)))){
      action = Math.min(  this.props.display.items.page + parseInt(action), Math.ceil(this.props.display.items.count / (this.props.display.items.limit || 30)));
      console.log(action)
    }
    if(typeof this.props.setPage === 'function'){
      this.props.setPage({action:action});
    }
  }
  componentDidMount(){
      window.addEventListener("scroll", this.showPointer);
  }
  showPointer = () => {
    if(window.scrollY > 300 && !this.state.upper) {
      this.setState({upper: true})
    }
    else if(window.scrollY < 300 && this.state.upper){
      this.setState({upper: false});
    }
  }
  componentWillUnmount(){
    window.removeEventListener("scroll", this.showPointer);
  }
  render() {
    if(this.props.show && this.props.display.items){
        var pageLocation;
        if(this.props.display.items.page){
          pageLocation= this.props.display.items.page.toString() + '/' + Math.ceil(this.props.display.items.count / (this.props.display.items.limit || 30));
        }
        var upper = 'upper page_btn';
        if(this.state.upper){
            upper += ' visible';
        }
        return (
          <div className="PageState">
            <button className={upper} onClick={() => {window.scrollTo(0,0)}}><i className="fa fa-chevron-up" aria-hidden="true" /></button>
            <select style={{display: 'none'}} className="page_length">
              <option value="30">30</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
            <div className="paging">
              <button className="page_btn" onClick={this.updatePage.bind(this,'start')}><i className="fa fa-angle-double-left" aria-hidden="true" /></button>
              <button className="page_btn" onClick={this.updatePage.bind(this,'-1')}><i className=" fa fa-angle-left" aria-hidden="true" /></button>
              <input className="page_no" id="page_no" onChange={this.updatePage.bind(this,'#page_no')} value={pageLocation} />
              <button className="page_btn" onClick={this.updatePage.bind(this,'+1')}><i className=" fa fa-angle-right" aria-hidden="true" /></button>
              <button className="page_btn" onClick={this.updatePage.bind(this, Math.ceil(this.props.display.items.count / (this.props.display.items.limit || 30)))}><i className=" fa fa-angle-double-right" aria-hidden="true" /></button>
            </div>
          </div>
        );
    }
    return null;
  }
}

export default PageState;



// WEBPACK FOOTER //
// ./src/PageState.js